<app-header
        [fixed]="true"
        [navbarBrandFull]="{src: 'assets/img/brand/logo.png?v=2', width: 150, height: 25, alt: ('kaitoriya.brand_name' | transloco)}"
        [navbarBrandMinimized]="{src: 'assets/img/brand/logo.png?v=2', width: 30, height: 30, alt: ('kaitoriya.brand_name' | transloco)}"
        [sidebarToggler]="'lg'"
        [asideMenuToggler]="false"
        [mobileAsideMenuToggler]="false">
    <ul class="nav navbar-nav ml-auto">
        <li class="nav-item"><app-languages></app-languages></li>
    </ul>
    <ul class="nav navbar-nav mr-5" *ngIf="user">
        <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link d-none d-lg-block" dropdownToggle>{{ user.name }}</a>
        </li>
    </ul>
</app-header>
<div class="app-body">
    <div class="sidebar">
        <nav class="sidebar-nav">
            <app-workspace-nav></app-workspace-nav>
        </nav>
    </div>
    <main class="main">
        <router-outlet></router-outlet>
    </main>
</div>
<footer class="app-footer">
    <span>Powered by <a href="https://www.kobe-ap.com/">株式会社アクティブプロモーション</a></span>
</footer>
